import React from "react";
import { Routes, Route } from "react-router-dom";
import "./custom.css";
import "./i18n";
import AdnMenu from "./components/common/adnMenu/AdnMenu";
import { useSelector } from "react-redux";
import AdnEmptyLayoutContent from "./components/common/adnMenu/AdnEmptyLayoutContent";
import ProtectedRoute from "./components/common/route/ProtectedRoute";
import { PageTitleProvider } from "./contexts/PageTitleContext";
import {
  AppRoutes,
  AuthenticatedRoutes,
  UnauthenticatedRoutes,
} from "./AppRoutes";
import { TenantProvider } from "./contexts/TenantContext";

function App() {
  const { userIsAuthenticated } = useSelector(
    (state) => state.userIsAuthenticated
  );
  return (
    <PageTitleProvider>
      <TenantProvider>
        {!userIsAuthenticated && (
          <AdnEmptyLayoutContent>
            <Routes>
              {UnauthenticatedRoutes.map((route, index) => {
                return (
                  <Route
                    key={index}
                    path={route.path}
                    element={route.element}
                  />
                );
              })}
            </Routes>
          </AdnEmptyLayoutContent>
        )}
        {userIsAuthenticated && (
          <AdnMenu>
            <Routes>
              {AuthenticatedRoutes.map((route, index) => {
                return route.roles ? (
                  <Route
                    key={index}
                    path={route.path}
                    element={
                      <ProtectedRoute
                        redirectTo={AppRoutes.forbidden.path}
                        roles={route.roles}
                      >
                        {route.element}
                      </ProtectedRoute>
                    }
                  />
                ) : (
                  <Route
                    key={index}
                    path={route.path}
                    element={route.element}
                  />
                );
              })}
            </Routes>
          </AdnMenu>
        )}
      </TenantProvider>
    </PageTitleProvider>
  );
}

export default App;
